import gql from 'graphql-tag';

const DOCUMENT_DELETE= gql`
mutation documentDelete ($id:ID!) {
  documentDelete(id:$id) 
}
`;

export default DOCUMENT_DELETE;